import React from 'react'
import useTranslations from 'src/hooks/useTranslations'
import { faTools } from '@fortawesome/pro-regular-svg-icons/faTools'
import { faTools as faToolsSolid } from '@fortawesome/pro-solid-svg-icons/faTools'
import { reverse } from 'src/routes/config'
import MainMenuItem from 'src/components/Menu/MainMenuItem'

export default function SupportWorkspaceMenu({
    isOpen,
    parentIsCollapsed,
    onClick,
}) {
    const { t } = useTranslations('MainMenu', 'MainMenu')

    return (
        <MainMenuItem
            icon={faTools}
            iconActive={faToolsSolid}
            title={t('Support workspace')}
            isOpen={isOpen}
            onClick={onClick}
            parentIsCollapsed={parentIsCollapsed}
            to={reverse('support-workspace-tickets')}
        />
    )
}
